/**
 * SpecialtyChips — compact chip list for marketplace listings + passport cards.
 * Shows up to `max` chips then "+N more". Silent when empty.
 *
 * Props:
 *  - items:  string[]    — specialty labels
 *  - max:    number = 3
 *  - tone:   "default" | "subtle" — adjusts visual weight
 *  - testidPrefix: string = "spec-chip"
 */
export default function SpecialtyChips({ items = [], max = 3, tone = "default", testidPrefix = "spec-chip" }) {
  if (!items || items.length === 0) return null;
  const visible = items.slice(0, max);
  const overflow = items.length - visible.length;
  const baseCls = tone === "subtle"
    ? "bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border-slate-200 dark:border-slate-700"
    : "bg-violet-50 dark:bg-violet-900/30 text-violet-700 dark:text-violet-200 border-violet-200/70 dark:border-violet-700/50";

  return (
    <div data-testid={`${testidPrefix}-row`} className="flex flex-wrap gap-1">
      {visible.map((s) => (
        <span
          key={s}
          data-testid={`${testidPrefix}-${slug(s)}`}
          title={s}
          className={`inline-flex items-center px-1.5 py-0.5 rounded-full border text-[10px] font-bold ${baseCls}`}
        >
          {s}
        </span>
      ))}
      {overflow > 0 && (
        <span
          data-testid={`${testidPrefix}-overflow`}
          title={items.slice(max).join(" · ")}
          className={`inline-flex items-center px-1.5 py-0.5 rounded-full border text-[10px] font-bold ${baseCls}`}
        >
          +{overflow} more
        </span>
      )}
    </div>
  );
}

function slug(s) {
  return (s || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
}
